exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-control[data-v-38d44fa5]:disabled {\n    opacity: 0.7 !important;\n}\n\n", ""]);

// exports
